export { default } from "./FullWidthContent";
export * from "./FullWidthContent";
